/* istanbul ignore file */

export class AllSelection {
    static readonly ALL = '-1';
}
